"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputValidationMessage = require("../input-validation-message");
var _fieldBase = _interopRequireDefault(require("../field-base"));
var _wrapWithRequiredAsterisk = _interopRequireDefault(require("../../utils/wrap-with-required-asterisk"));
require("./field.css");
var _excluded = ["children", "className", "containerProps", "customFieldStatus", "defaultValue", "displayStatus", "error", "errorMessage", "floatLabelActiveText", "floatLabelAriaHidden", "floatLabelId", "floatLabelVisible", "hintText", "id", "inputAddon", "maxLength", "maxLengthAriaMessage", "onBlur", "onChange", "onFocus", "required", "type", "value"];
/* eslint-disable complexity */
/* eslint-disable max-statements */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * A form field with validation support.
 */
var Field = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    containerProps = _ref.containerProps,
    customFieldStatus = _ref.customFieldStatus,
    defaultValue = _ref.defaultValue,
    displayStatus = _ref.displayStatus,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    errorMessage = _ref.errorMessage,
    floatLabelActiveText = _ref.floatLabelActiveText,
    _ref$floatLabelAriaHi = _ref.floatLabelAriaHidden,
    floatLabelAriaHidden = _ref$floatLabelAriaHi === void 0 ? false : _ref$floatLabelAriaHi,
    floatLabelId = _ref.floatLabelId,
    _ref$floatLabelVisibl = _ref.floatLabelVisible,
    floatLabelVisible = _ref$floatLabelVisibl === void 0 ? true : _ref$floatLabelVisibl,
    hintText = _ref.hintText,
    id = _ref.id,
    inputAddon = _ref.inputAddon,
    maxLength = _ref.maxLength,
    maxLengthAriaMessage = _ref.maxLengthAriaMessage,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    required = _ref.required,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var initialValue = value || defaultValue;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useState3 = (0, _react.useState)(initialValue === null || initialValue === void 0 ? void 0 : initialValue.length),
    _useState4 = _slicedToArray(_useState3, 2),
    hasValue = _useState4[0],
    setHasValue = _useState4[1];
  var _useState5 = (0, _react.useState)(''),
    _useState6 = _slicedToArray(_useState5, 2),
    ariaMaxLengthMessage = _useState6[0],
    setAriaMaxLengthMessage = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    currentValueLength = _useState8[0],
    setCurrentValueLength = _useState8[1];
  (0, _react.useEffect)(function () {
    if (currentValueLength === maxLength) {
      setTimeout(function () {
        return setAriaMaxLengthMessage(maxLengthAriaMessage);
      }, 1000);
    } else {
      setAriaMaxLengthMessage('');
    }
  }, [currentValueLength, maxLength]);
  var handleChange = function handleChange(ev) {
    var _ev$target, _ev$target2;
    if (onChange) {
      onChange(ev);
    }
    setCurrentValueLength(ev === null || ev === void 0 || (_ev$target = ev.target) === null || _ev$target === void 0 || (_ev$target = _ev$target.value) === null || _ev$target === void 0 ? void 0 : _ev$target.length);
    if (Boolean(ev === null || ev === void 0 || (_ev$target2 = ev.target) === null || _ev$target2 === void 0 || (_ev$target2 = _ev$target2.value) === null || _ev$target2 === void 0 ? void 0 : _ev$target2.length) !== hasValue) {
      setHasValue(!hasValue);
    }
  };
  var handleFocus = function handleFocus(ev) {
    if (onFocus) {
      onFocus(ev);
    }
    setIsFocused(true);
  };
  var handleBlur = function handleBlur(ev) {
    if (onBlur) {
      onBlur(ev);
    }
    setIsFocused(false);
  };
  var fieldId = id || (0, _uniqueId2["default"])('field');
  var hasInput = Boolean(hasValue || (value === null || value === void 0 ? void 0 : value.length));
  var validationId = "".concat(fieldId, "-validationHint");
  var hintTextId = "".concat(fieldId, "-hintText");
  var showValidationMessage = (0, _inputValidationMessage.getDisplayStatus)({
    displayStatus: displayStatus,
    error: error,
    errorMessage: errorMessage
  });
  var labelActiveText = required ? (0, _wrapWithRequiredAsterisk["default"])({
    children: floatLabelActiveText,
    error: error
  }) : floatLabelActiveText;
  var ariaDescribeByIds = [showValidationMessage ? validationId : null, hintText ? hintTextId : null];
  return /*#__PURE__*/_react["default"].createElement(_fieldBase["default"], {
    childId: fieldId,
    className: className,
    containerProps: containerProps,
    customFieldStatus: customFieldStatus,
    error: error,
    errorMessage: errorMessage,
    errorMessageDisplayStatus: displayStatus,
    floatLabelActive: hasInput || isFocused,
    floatLabelActiveText: floatLabelActiveText && labelActiveText,
    floatLabelAriaHidden: floatLabelAriaHidden,
    floatLabelId: floatLabelId,
    floatLabelText: required ? (0, _wrapWithRequiredAsterisk["default"])({
      children: children,
      error: error
    }) : children,
    floatLabelVisible: floatLabelVisible,
    hintText: hintText,
    hintTextId: hintTextId,
    validationId: validationId
  }, /*#__PURE__*/_react["default"].createElement("input", _extends({
    "aria-describedby": ariaDescribeByIds.filter(Boolean).join(' '),
    "aria-invalid": error,
    "aria-required": required,
    className: "fieldInput text-sm",
    id: id,
    maxLength: maxLength,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    ref: ref,
    type: type,
    value: value
  }, otherProps)), /*#__PURE__*/_react["default"].createElement("div", {
    "aria-live": "polite",
    className: "hiddenVisually"
  }, ariaMaxLengthMessage), inputAddon);
});
Field.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Text or element(s) used as children of the field's `label` element.
   */
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string,
  /**
   * Props applied to the field's outer container.
   */
  containerProps: _propTypes["default"].object,
  /**
   * A flag indicating that the field uses a custom element to display field status
   * and should not wrap error messages in a `FieldStatus` component.
   */
  customFieldStatus: _propTypes["default"].bool,
  defaultValue: _propTypes["default"].string,
  /**
   * A flag indicating that the field should display its error message irrespective of the field's
   * error status. If set to `true`, the error message will display no matter what. If set to
   * `false`, it will never display.
   */
  displayStatus: _propTypes["default"].bool,
  /**
   * A flag indicating that the field is in an error state.
   */
  error: _propTypes["default"].bool,
  /**
   * A message to display when the field is in an error state. Wrapped in a `FieldStatus` component
   * by default.
   */
  errorMessage: _propTypes["default"].node,
  /**
   * Optional text used as field's `label` element when the the field is in an active state.
   */
  floatLabelActiveText: _propTypes["default"].string,
  /**
   * Set to true to hide float label text from screen readers
   */
  floatLabelAriaHidden: _propTypes["default"].bool,
  /**
   * Optional id to be set on the associated label, can be useful for
   * creating accessibility relationships between elements
   */
  floatLabelId: _propTypes["default"].string,
  /**
   * Set to false to only show the label when the field does not have a value
   */
  floatLabelVisible: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  /**
   * An additional element rendered within the field after the `input` element. Used to apply
   * extra buttons and labels on the edges of fields.
   */
  inputAddon: _propTypes["default"].node,
  /**
   * Optional hint text to be displayed.
   */
  hintText: _propTypes["default"].node,
  maxLength: _propTypes["default"].number,
  /**
   * An optional Aria Message to indicate when the maximum length has been reached.
   */
  maxLengthAriaMessage: _propTypes["default"].string,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  value: _propTypes["default"].string
} : {};
var _default = exports["default"] = Field;